export const isBannerRecommended = product =>
    product.banner.categories.length > 0 &&
    product.banner.categories[0].includes('recommended');
